<template>
  <div class="doctorPage">
    <div class="centerHome">
      <div class="ccHomel">
        <div class="compentTable">
          <div class="info-card">
            <div class="date">{{ taskInfo.Name }}</div>
            <div class="line"></div>
            <div class="title">
              抽样类型：
              <span class="label">{{ taskInfo.CategoryName }}</span>
            </div>
          </div>
          <div class="func-bar">
            <div class="title">未抽样分发报告(共{{ list.length }}份)</div>
          </div>
          <el-table 
            class="qcTable"
            ref="tableRef" 
            :data="list.slice((page - 1) * pageSize, page * pageSize)" 
            show-overflow-tooltip 
            v-loading="loading"
          >
            <el-table-column label="中心名称" prop="HospitalName" min-width="100"></el-table-column>
            <el-table-column label="审核医生" prop="ModalityType" v-if="taskInfo.SubjectType == 2">
							<template slot-scope="scope">
								<span>{{scope.row.FirstApproverName}}</span>
							</template>
						</el-table-column>
						<el-table-column label="影像技师" prop="ModalityType" v-if="taskInfo.SubjectType == 3">
							<template slot-scope="scope">
								<span>{{scope.row.TechnictionName}}</span>
							</template>
						</el-table-column>
						<el-table-column label="诊断医生" prop="ModalityType" v-if="taskInfo.SubjectType == 4">
							<template slot-scope="scope">
								<span>{{scope.row.ReportSubmitterName}}</span>
							</template>
						</el-table-column>
            <el-table-column label="报告编码" prop="AccNo" min-width='150'></el-table-column>
            <el-table-column label="设备类型" prop="ModalityType" min-width='90'></el-table-column>
            <el-table-column label="检查项目" prop="CheckingItems" min-width='230'></el-table-column>
            <el-table-column prop="ReportScore" label="报告评分" key='1' v-if="taskInfo.CategoryName=='报告'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column prop="ReportScoreDiff" label="报告分差" key='2' v-if="thisOnly&&(taskInfo.CategoryName=='报告'||taskInfo.CategoryName=='影像和报告')"></el-table-column>
						<el-table-column prop="ImageScore" label="影像评分" key='3' v-if="taskInfo.CategoryName=='影像'||taskInfo.CategoryName=='影像和报告'"></el-table-column>
						<el-table-column prop="ImgScoreDiff" label="影像分差" key='4' v-if="thisOnly&&(taskInfo.CategoryName=='影像'||taskInfo.CategoryName=='影像和报告')"></el-table-column>
						<el-table-column prop="QCTimes" label="质控进度" key='5' v-if="thisOnly&&(taskInfo.DistributionMethod!=''&&taskInfo.DistributionMethod!='未知'&&taskInfo.DistributionMethod!='null')">
							<template slot-scope="scope">
								<el-tooltip effect="dark" placement="top-start">
									<div class="progress">
										<div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100)}%`">
										</div>
										<span class="sr-only">{{(Math.floor((scope.row.CompleteCount/scope.row.QCTimes)*100))}}%</span>
									</div>
									<div slot="content" class="tableTooltip">
										<div>
											<em></em>
											<span>已完成数量:{{scope.row.CompleteCount}}</span>
										</div>
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
            <el-table-column prop="Status" label="质控状态" column-key='Status' min-width="100">
							<template slot-scope="scope">
								<div v-if="scope.row.TotalStatus == 0">
									<span>{{scope.row.Status | formatStatus}}</span>
								</div>
								<div v-else-if="scope.row.Status == 0">
									<span>{{scope.row.TotalStatus | formatStatus}}</span>
								</div>
							</template>
						</el-table-column>
            <el-table-column label="完成时间" prop="QCDt" min-width='150'></el-table-column>
            <el-table-column label="分发专家" prop="QCPeoPleName" min-width='90'></el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <span class="tableOpe" v-if="scope.row.TotalStatus<=123" @click="handleDetails(scope.row,'table')">查看详情</span>
                  <span class="tableOpe" 
                    v-else-if="scope.row.TotalStatus>123&&Array.isArray(scope.row.ExpertUserGuids) && scope.row.ExpertUserGuids.length<=1"
                    @click="handleDetails(scope.row,'length')"
                  >
                    查看结果
                  </span>
                </template>
              </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination 
              class="pageAll"
              layout="prev, pager, next"
              :total="list.length"
              :page-size='pageSize'
              :current-page='page' 
              @current-change='currentChange'
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import axios from '@/js/api'
import Button from '@/components/Common/Button/index'
export default {
  components: { Button },
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      expertUserId: '',
      thisOnly: false
    }
  },
  filters: {
    formatStatus: function(value) {
      return {
        '': '不限',
        '120': '已抽样',
        '123': '已分配',
        '125': '进行中',
        '130': '已完成',
        '140': '申诉中',
        '170': '已归档'
      } [value] || '不限';
    }
  },
  computed: {
    ...Vuex.mapState('managerPlanList', ['taskInfo', 'qcresultsList']),
  },
  activated() {
    const { expertUserId } = this.$route.query
    this.expertUserId = expertUserId
    this.getDetails()
  },
  methods: {
    ...Vuex.mapMutations('breadcrumb', ['setqcresultsShow']),
    ...Vuex.mapMutations('doctor', ['setDetailsParameter']),
    ...Vuex.mapActions('managerPlanList', ['GetQCResultsByTask']),
    // 获取详情信息
    getDetails() {
      this.list = []
      this.loading = true
      axios.ajaxGet('get',Api.api.manager.getTaskDdistributeDetails, {
        samplingTaskGuid: this.taskInfo.SamplingTaskGuid,
        expertUserId: this.expertUserId
      }).then(res=>{
        const { StatusCode, Result } =  Object(res.data)
        if (StatusCode === 200) {
          this.list = Result || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 表格分页参数改变
    currentChange(val) {
      this.page = val
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    // 查看详情
    handleDetails(row) {
      let arg = arguments[1];
			this.qcresultsList.Name = row.Name
      if (arg) {
        this.setqcresultsShow(false)
        this.qcresultsList.expertUserId = row.ExpertUserGuids[0]
        this.qcresultsList.ReportGuid = row.ReportGuid
        this.qcresultsList.SamplingTaskGuid = row.SamplingTaskGuid
      } else {
        this.setqcresultsShow(true);
        this.qcresultsList.expertUserId = row.ExpertUserId
        this.qcresultsList.ReportGuid = this.datas.ReportGuid
        this.qcresultsList.SamplingTaskGuid = this.datas.SamplingTaskGuid
      }
      this.setDetailsParameter({
        reportGuid: this.qcresultsList.ReportGuid,
        samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
        ExpertUserGuid: this.qcresultsList.expertUserId
      })
      this.GetQCResultsByTask({
        samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
        reportGuid: this.qcresultsList.ReportGuid
      })
      this.$router.push("/home/doctor/scoring")
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.compentTable {
  .info-card {
    display: flex;
    align-items: center;
    height: 30px;
    line-height: 30px;
    padding-bottom: 12px;
    .date {
      font-size: 16px;
      font-weight: 500;
    }
    .line {
      width: 1px;
      height: 14px;
      margin: 0 18px;
    }
    .title {
      font-size: 14px;
      font-weight: 300;
      .label {
        background: rgba(36,138,253,0.2);
        border-radius: 10px;
        border: 1px solid #248AFD;
        padding: 3px 10px;
      }
    }
  }
  .func-bar {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
  }
}
</style>
